import axios from "axios";
import uuid from "react-uuid";
import CryptoJS from "crypto-js";
import Base64 from "crypto-js/enc-base64";
import { s360ConfigService } from "./S360Config";
import HWUser from "../HWLibrary/HWUser";

class APIService {
  constructor() {
    if (!APIService.shared) {
      APIService.shared = this;
    }
    return APIService.shared;
  }

  logInWithFormData = (formDetails) => {
    return this.logIn({ form: formDetails });
  };
  logInWithUserData = (chatUserModel) => {
    return this.logIn({ user: chatUserModel });
  };

  logIn = (data) => {
    const url =
      "https://" + s360ConfigService.config.loghost + "/bmapi/webchatv2/login";
    const nonce = uuid();
    const timestamp = new Date().getTime();
    const bearerToken = this.generateBearerToken(url, nonce, timestamp);
    const config = {
      headers: {
        Authorization: bearerToken,
        "content-type": "application/json",
      },
      params: { nonce: nonce, timestamp: timestamp },
    };

    console.log("Data in Apiservice",sessionStorage.getItem(`s360-user-config-${s360ConfigService.config.configId}`))
    data["configId"] = s360ConfigService.config.configId;
    data["host"] = s360ConfigService.config.host;
    data["user"] =    Object.keys( s360ConfigService.s360UserConfig).length === 0 ? JSON.parse( sessionStorage.getItem(`s360-user-config-${s360ConfigService.config.configId}`)) : s360ConfigService.s360UserConfig;

    const configId = s360ConfigService.config.configId;
    let anonymousBrowserId =
      configId +
      "-" +
      (s360ConfigService.clientHostId ? s360ConfigService.clientHostId : nonce);

    // if customerId from pervious login is present than use that as primaryField value
    const customerId = HWUser.customerId();
    if (customerId)
      anonymousBrowserId = customerId

    if (s360ConfigService.config.anonymous) {
      let fitems =
        s360ConfigService.config && s360ConfigService.config.form
          ? s360ConfigService.config.form.sort((i1, i2) => {
              return i1.selposition - i2.selposition;
            })
          : [];
      fitems.map((item) => {
        // UUID per device.
        if (item.primaryField) {
          data.form[item.label] = anonymousBrowserId;
        } else {
          data.form[item.label] = "anonymous";
        }
      });
    }

    return axios.post(url, data, config);
  };

  uploadMedia = (fileToUpload, mediaType, sessionId) => {
    const url =
      "https://" + s360ConfigService.config.loghost + "/bmapi/jabber/upload";
    const configId = s360ConfigService.config.configId;
    const nonce = uuid();
    const timestamp = new Date().getTime();
    const bearerToken = this.generateBearerToken(
      url,
      nonce,
      timestamp,
      mediaType
    );
    const config = {
      headers: {
        Authorization: bearerToken,
        "content-type": "multipart/form-data",
      },
      params: { nonce: nonce, timestamp: timestamp, configId: configId },
    };
    if (mediaType) {
      config.params.type = mediaType;
    }
    config.params.sessionId = sessionId;
    const formData = new FormData();
    formData.append("file", fileToUpload);
    return axios.post(url, formData, config);
  };

  // Private Method, Tested, Working.
  generateBearerToken = (serviceUrl, nonce, timestamp, mediaType) => {
    let dataString =
      "POST&" +
      encodeURIComponent(serviceUrl) +
      "&" +
      encodeURIComponent("nonce=" + nonce) +
      encodeURIComponent("&timestamp=" + timestamp);
    if (mediaType) {
      dataString += encodeURIComponent("&type=" + mediaType);
    }

    let sha1Signature = CryptoJS.HmacSHA1(
      dataString,
      s360ConfigService.config.token
    );
    let encodedSignature = Base64.stringify(sha1Signature);

    return "Bearer " + encodedSignature;
  };

  createTicketWithFormData = (data) => {
    // Private Method
    // const url         = "http://bm.com:8080/bm/spring/jabber/email/notification";
    const url =
      "https://suitex.simplify360.com/spring/jabber/email/notification";
    //const url   ="https://devdata.simplify360.com/bmapi/test";
    const config = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        //'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, POST, DELETE, OPTIONS',
        "Access-Control-Allow-Origin": "*",
        //'Access-Control-Allow-Headers': 'Content-Type',
        //'Access-Control-Max-Age': '86400',
        //'Access-Control-Expose-Headers': 'Content-Length, X-JSON'
        //"Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept"
      },
    };

    var dt = {};
    dt["data"] = data;
    dt["configId"] = s360ConfigService.config.configId;
    // data["host"]     = s360ConfigService.config.host;
    return axios.post(url, dt, config);
  };
}

var apiService = new APIService();
export default apiService;
